export function scaledZeroOrMinOrMax(_ref) {
  var scaleName = _ref.scaleName,
    scale = _ref.scale,
    mode = _ref.mode;
  var domain = "domain('".concat(scaleName, "')");
  if (!scale || !scaleName) {
    return undefined;
  }
  var min = "".concat(domain, "[0]");
  var max = "peek(".concat(domain, ")"); // peek = the last item of the array
  // If there is a scale (and hence its name)
  var domainHasZero = scale.domainHasZero();
  // zeroOrMin or zeroOrMax mode
  if (domainHasZero === 'definitely') {
    return {
      scale: scaleName,
      value: 0
    };
  } else if (domainHasZero === 'maybe') {
    var nonZeroValue = mode === 'zeroOrMin' ? min : max;
    return {
      signal: "scale('".concat(scaleName, "', inrange(0, ").concat(domain, ") ? 0 : ").concat(nonZeroValue, ")")
    };
  } else {
    // domainHasZero === 'definitely-not'
    return {
      signal: "scale('".concat(scaleName, "', ").concat(mode === 'zeroOrMin' ? min : max, ")")
    };
  }
}